import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import MobileKasaOzeti from './pages/MobileKasaOzeti';
import MobileGunSonu from './pages/MobileGunSonu';
import MobileToptancilar from './pages/MobileToptancilar';
import MobileTamirat from './pages/MobileTamirat';
import MobileFisler from './pages/MobileFisler';
import MobileHurda from './pages/MobileHurda';
import MobilePersonel from './pages/MobilePersonel';
import reportWebVitals from './reportWebVitals';
import { installApiAuth } from './utils/apiAuth';
import { startVersionCheck } from './utils/versionCheck';

// Tüm API isteklerine oturum token'ı eklenir (backend kimlik doğrulaması) — bkz. utils/apiAuth.js
installApiAuth();
// Uzun süre açık kalan sekmeler (kiosk/terminal) yeni deploy'u fark edip yenilenmeye teşvik edilir
startVersionCheck();

// iOS admin uygulamasının WebView'da açtığı rapor sayfaları: App (login, mağaza seçimi,
// hatırlatmalar) yüklenmeden doğrudan gösterilir — bkz. MobileKasaOzeti.js
const MOBILE_PAGES = {
  '/mobile/kasa-ozeti': MobileKasaOzeti,
  '/mobile/gun-sonu': MobileGunSonu,
  '/mobile/toptancilar': MobileToptancilar,
  '/mobile/tamirat': MobileTamirat,
  '/mobile/fisler': MobileFisler,
  '/mobile/hurda': MobileHurda,
  '/mobile/personel': MobilePersonel,
};
const MobilePage = MOBILE_PAGES[window.location.pathname.replace(/\/+$/, '')];

// Sayı inputlarında scroll ile değer değişmesini engelle
document.addEventListener('wheel', (e) => {
  if (document.activeElement && document.activeElement.type === 'number') {
    document.activeElement.blur();
  }
}, { passive: true });

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {MobilePage ? <MobilePage /> : <App />}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
